import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const uploadBulkQuizApi = createAsyncThunk(
  "short-video-bulk/upload",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.post(apiRoutes.quizAction("bulk-add-questions", 1), data, { headers: { "Content-Type": "multipart/form-data" } })

      return response?.data;
    } catch (error) {
      //console.log("error",error);
      return rejectWithValue(error?.response?.data);
    }
  }
);
const intialState = { result: [], loading: false, error: null, message: "" }
const uploadBulkQuizSlice = createSlice({
  name: "quiz_bulk_upload",
  initialState: { result: [], loading: false, error: null, message: "" },
  reducers: {
    resetImage: () => intialState,
  },
  extraReducers: (builder) => {
    builder.addCase(uploadBulkQuizApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(uploadBulkQuizApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(uploadBulkQuizApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});
export const { resetImage } = uploadBulkQuizSlice.actions;
export const uploadBulkQuizReducer = uploadBulkQuizSlice.reducer;
